import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()

export class DashboarddemoService{
  
    api = environment.ESDapiUrl;
    constructor(private http: HttpClient) {}

    getMyLearningsOfEmployee(UserId:number,employeeId:number):Observable<any>{
      const url = `${this.api}User/FetchMyLearningsOfEmployee/${UserId}?isEmployeeId=${employeeId}`
      return this.http.get<any>(url);

    }
    GetTopLearners():Observable<any>{
      const url = `${this.api}Program/GetTopLearners`
      return this.http.get<any>(url);

    }
    getRecommendedProgramsOfEmployee(data:any):Observable<any>{
      const url = `${this.api}User/FetchRecommendedProgramsOfEmployee`
      return this.http.post<any>(url,data);

    }
    GetUserProgramDetailsByEmployeeId(employeeId:number):Observable<any>{
      const url = `${this.api}Employee/GetUserProgramDetailsByEmployeeId?employeeId=${employeeId}`
      return this.http.get<any>(url);

    }


}